import { ref } from '../config/firebase'

export function getUser(userId) {
    return ref.child(`USERS/${userId}`).once('value')
        .then((userSnapshot) => userSnapshot.val())
}

export function updateUser(userId, params) {
    return ref.child(`USERS/${userId}`)
        .update(params)
}



// WEBPACK FOOTER //
// ./src/firebase/user.js